import { render, staticRenderFns } from "./DrugDraft.vue?vue&type=template&id=2477ed93&lang=pug&"
import script from "./DrugDraft.vue?vue&type=script&lang=ts&"
export * from "./DrugDraft.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports